import { render, staticRenderFns } from "./classhourList.vue?vue&type=template&id=3abba373&"
import script from "./classhourList.vue?vue&type=script&lang=js&"
export * from "./classhourList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports